import React, { useCallback, useEffect, useState } from "react";
import { Row, Col, Form, Button, Container, Image } from "react-bootstrap";
import "./index.css";
import CustomButton from "../../../common/CustomButton";
import { useSelector, useDispatch } from "react-redux";
import { getApi, patchCompanyInfo, postGetGSTPrice } from "../../../../actions/structure.action";
import isEmpty from "../../../../utils/is-Empty";
import { capitalize, debounce, set } from "lodash";
import CustomSelectDropdown from "../../../common/CustomSelectDropdown";
import FilterObjectsByKeyValue from "../../../../utils/FilterObjectsByKeyValue";
import { paymenttypesString } from "../../../../helpers/table-structures";
import Spinner from "../../../common/Spinner";

const Companyinformation = ({ title = "Comapny INFO" }) => {
  const dispatch = useDispatch();
  const [errorMsg, setErrorMsg] = useState("");
  const [isUpdateMode, setIsUpdateMode] = useState(false);
  const [uploadFormObj, setUploadFormObj] = useState({});
  const [file, setFile] = useState(null);
  const { requestCall, auth, companyInfo, bhareeAdminBasicTable } = useSelector((state) => {
    return state;
  });

  useEffect(() => {
    getApi("getCompanyInfo", dispatch);
  }, [dispatch]);

  useEffect(() => {
    console.log("----- Company Info -----", companyInfo?.data);
    if (isEmpty(companyInfo?.data)) {
      return;
    }

    const deliveryChargeWithoutGST =
      parseFloat(companyInfo?.data?.business_info?.deliveryCharge || 0) / 1.18;
    const handlingChargesWithoutGST =
      parseFloat(companyInfo?.data?.business_info?.handling_charges || 0) / 1.18;

    setUploadFormObj(companyInfo.data);
    setUpdatedForm("gst_no", companyInfo.data?.business_info?.gst_no);
    setUpdatedForm("deliveryCharge", deliveryChargeWithoutGST.toFixed(2));
    setUpdatedForm("deliveryChargeFinal", companyInfo.data?.business_info?.deliveryCharge);
    setUpdatedForm("handling_charges", handlingChargesWithoutGST.toFixed(2));
    setUpdatedForm("handlingChargesFinal", companyInfo.data?.business_info?.handling_charges);
    setIsUpdateMode(false);
  }, [companyInfo]);

  const setUpdatedForm = (key, value) => {
    let updatedObj = {};
    updatedObj[key] = value;

    setUploadFormObj((previousValues) => ({
      ...previousValues,
      ...updatedObj,
    }));
  };

  const handleFileChange = (e) => {
    const selectedFile = e.target.files[0];
    if (selectedFile && selectedFile.size > 2 * 1024 * 1024) {
      setErrorMsg("❌ File size must be ≤ 2MB");
      return;
    }
    setFile(selectedFile);
    setErrorMsg("");
  };

  const updateCompanyInfo = (e) => {
    e.preventDefault();
    setErrorMsg("");
    if (
      !isEmpty(uploadFormObj) &&
      Object.prototype.hasOwnProperty.call(uploadFormObj, "contact_person_name") &&
      !isEmpty(uploadFormObj.contact_person_name) &&
      Object.prototype.hasOwnProperty.call(uploadFormObj, "gst_no") &&
      !isEmpty(uploadFormObj.gst_no)
    ) {
      let formData = new FormData();
      formData.append("contactPerson", uploadFormObj.contact_person_name);
      formData.append("gst", uploadFormObj.gst_no);
      formData.append("deliveryCharge", uploadFormObj.deliveryChargeFinal);
      formData.append("handling_charges", uploadFormObj.handlingChargesFinal);

      if (!isEmpty(uploadFormObj.payment_types)) {
        console.log("uploadFormObj.payment_types : ", uploadFormObj.payment_types);
        const idsString = uploadFormObj.payment_types.map((item) => item.id).join(",");
        formData.append("payment_types", idsString);
      }

      // 👇 Add signature file if selected
      if (file) {
        formData.append("signature", file);
      }

      if (isUpdateMode) {
        if (isEmpty(uploadFormObj?.business_info?.authorized_signature) && !file) {
          setErrorMsg("Please upload authorized signature.");
        } else {
          patchCompanyInfo(formData, dispatch);
        }
      }
    } else {
      setErrorMsg("Please fill all the required fields");
    }
  };

  const handleCalculateDeliveryCharge = (e) => {
    const value = e.target.value;
    // Add your calculation logic here
    console.log("Calculating delivery charge for value:", value);
    debouncedUpdatePrice(value, "deliveryChargeFinal");
  };

  const handleCalculateHandlingCharges = (e) => {
    const value = e.target.value;
    // Add your calculation logic here
    console.log("Calculating handling charges for value:", value);
    debouncedUpdatePrice(value, "handlingChargesFinal");
  };

  const debouncedUpdatePrice = useCallback(
    debounce((value, fieldName) => {
      let obj = {};
      obj["price"] = value;
      postGetGSTPrice(obj, dispatch).then((res) => {
        if (res && res.data) {
          // Handle the response data as needed
          console.log("Calculated Price Data:", res.data);
          if (res.data.success) {
            setUpdatedForm(fieldName, res.data.data.gstAmount.toFixed(2));
          }
        }
      });
    }, 1000), // Adjust delay as needed
    [],
  );

  return (
    <Container className="p-0 company-info-container">
      {companyInfo?.loading ? (
        <Spinner />
      ) : !isEmpty(companyInfo?.data) && !isUpdateMode ? (
        <Row className="company-info m-0">
          <Row className="heading-div ">
            <h5 className="text-uppercase p-0 m-0">{title}</h5>
            <p
              style={{ cursor: "pointer" }}
              onClick={() => {
                setIsUpdateMode(true);
              }}
            >
              {"Edit"}
            </p>
          </Row>
          <hr />
          <Row className="m-0 p-0 ">
            <Col xs={12} md={6} lg={4} className="p-0">
              <p>
                <span>{"Business Name:"}</span>
                <span className="mx-2 bold-span">
                  {" "}
                  {companyInfo?.data?.business_info?.business_name}
                </span>
              </p>
            </Col>
            <Col xs={12} md={6} lg={4} className="p-0">
              <p>
                <span>{"Contact Person:"}</span>
                <span className="mx-2 bold-span"> {companyInfo?.data?.contact_person_name}</span>
              </p>
            </Col>
            <Col xs={12} md={6} lg={4} className="p-0">
              <p>
                <span>{"Email:"}</span>
                <span className="mx-2 bold-span"> {companyInfo?.data?.email}</span>
              </p>
            </Col>
            <Col xs={12} md={6} lg={4} className="p-0">
              <p>
                <span>{"Mobile Number:"}</span>
                <span className="mx-2 bold-span">{companyInfo?.data?.mobile_number}</span>
              </p>
            </Col>
            <Col xs={12} md={6} lg={4} className="p-0">
              <p>
                <span>{`${capitalize(companyInfo?.data?.roleName)} Category:`}</span>
                <span className="mx-2 bold-span">
                  {capitalize(companyInfo?.data?.roleTypeName)}
                </span>
              </p>
            </Col>
            <Col xs={12} md={6} lg={4} className="p-0">
              <p>
                <span>{"GST:"}</span>
                <span className="mx-2 bold-span">{companyInfo?.data?.business_info?.gst_no}</span>
              </p>
            </Col>
            <Col xs={12} md={6} lg={4} className="p-0">
              <p>
                <span>{"Delivery Charges (Per Case):"}</span>
                <span className="mx-2 bold-span">
                  ₹{" "}
                  {companyInfo?.data?.business_info?.deliveryCharge
                    ? parseFloat(companyInfo?.data?.business_info?.deliveryCharge).toFixed(2)
                    : 0.0}
                </span>
              </p>
            </Col>
            <Col xs={12} md={6} lg={4} className="p-0">
              <p>
                <span>{"Handling Charges (Per Case):"}</span>
                <span className="mx-2 bold-span">
                  ₹ {companyInfo?.data?.business_info?.handling_charges}
                </span>
              </p>
            </Col>
            <Col xs={12} md={6} lg={4} className="p-0">
              <p>
                <span>{"Payment Types:"}</span>
                <span className="mx-2 bold-span">
                  {paymenttypesString(companyInfo?.data?.business_info?.payment_types)}
                </span>
              </p>
            </Col>
          </Row>
          <Row className="m-0 p-0">
            <Col xs={12} md={12} className="px-0">
              <h5 className="text-uppercase p-0 m-0 mt-3 small">Authorized Signature</h5>
              {(() => {
                if (companyInfo?.data?.business_info?.authorized_signature) {
                  return (
                    <Image
                      className="img-fluid"
                      src={companyInfo?.data?.business_info?.authorized_signature}
                      alt="Authorized Signature"
                      style={{ height: "100px" }}
                    />
                  );
                } else {
                  return (
                    <p className="text-danger small px-0 mt-2 m-0">
                      Please upload authorized signature by clicking on the "Edit" button. This
                      signature will be shown in the invoice.
                    </p>
                  );
                }
              })()}
            </Col>
          </Row>
        </Row>
      ) : (
        <Row className="m-0 w-full  form-row ">
          <Form className=" modal-custom-class" onSubmit={updateCompanyInfo}>
            <Row className="m-0 mb-2 title-button-row">
              <h2>{!isUpdateMode ? `${title}` : `Update ${title}`}</h2>
              <CustomButton
                buttonClasses="view-switch-btn"
                onClick={() => setIsUpdateMode(!isUpdateMode)}
              >
                {!isUpdateMode ? "Edit" : "View"}
              </CustomButton>
            </Row>
            <Row className="m-0">
              <Col xs={12} sm={12} md={6} className="form-col ">
                <Form.Group className="mb-3">
                  <Form.Label>{"Business Name"}</Form.Label>
                  <Form.Control
                    type="txt"
                    value={
                      !isEmpty(uploadFormObj) ? uploadFormObj?.business_info?.business_name : "*_*"
                    }
                    disabled
                  />
                </Form.Group>
                <Form.Group className="mb-3">
                  <Form.Label>{"Mobile Number"}</Form.Label>
                  <Form.Control
                    type="text"
                    value={!isEmpty(uploadFormObj) ? uploadFormObj.mobile_number : "*_*"}
                    disabled
                  />
                </Form.Group>
                <Form.Group className="mb-3">
                  <Form.Label>
                    {"GST"}
                    <span className="redStreSpan">{"*"}</span>
                  </Form.Label>
                  <Form.Control
                    type="text"
                    value={!isEmpty(uploadFormObj) ? uploadFormObj?.gst_no : "*_*"}
                    onChange={(e) => setUpdatedForm("gst_no", e.target.value)}
                    disabled={!isUpdateMode}
                  />
                </Form.Group>
                <Form.Group className="mb-3">
                  <Form.Label>
                    {"Delivery Charges (Per Case)"}
                    <span className="redStreSpan">{"*"}</span>
                    <span className="positiveMsg pointer">
                      {` Final (with 18% GST): ₹ ${uploadFormObj?.deliveryChargeFinal}`}
                    </span>
                  </Form.Label>
                  <Form.Control
                    type="text"
                    value={!isEmpty(uploadFormObj) ? uploadFormObj?.deliveryCharge : ""}
                    onChange={(e) => {
                      setUpdatedForm("deliveryCharge", e.target.value);
                      handleCalculateDeliveryCharge(e);
                    }}
                    disabled={!isUpdateMode}
                  />
                  <p className="m-0 p-0 text-danger small">
                    * Delivery charges should be entered without GST
                  </p>
                </Form.Group>
                <Form.Group className="mb-3">
                  <Form.Label>
                    {"Handling Charges (Per Case)"}
                    <span className="redStreSpan">{"*"}</span>
                    <span className="positiveMsg pointer">
                      {` Final (with 18% GST): ₹ ${uploadFormObj?.handlingChargesFinal}`}
                    </span>
                  </Form.Label>
                  <Form.Control
                    type="text"
                    value={!isEmpty(uploadFormObj) ? uploadFormObj?.handling_charges : ""}
                    onChange={(e) => {
                      setUpdatedForm("handling_charges", e.target.value);
                      handleCalculateHandlingCharges(e);
                    }}
                    disabled={!isUpdateMode}
                  />
                  <p className="m-0 p-0 text-danger small">
                    * Handling charges should be entered without GST
                  </p>
                </Form.Group>
              </Col>
              <Col xs={12} sm={12} md={6} className="form-col ">
                <Form.Group className="mb-3">
                  <Form.Label>{"Email"}</Form.Label>
                  <Form.Control
                    type="email"
                    value={!isEmpty(uploadFormObj) ? uploadFormObj.email : "*_*"}
                    disabled
                  />
                </Form.Group>

                <Form.Group className="mb-3">
                  <Form.Label>{`${capitalize(uploadFormObj?.roleName)} Category`}</Form.Label>
                  <Form.Control
                    type="text"
                    value={!isEmpty(uploadFormObj) ? capitalize(uploadFormObj.roleTypeName) : "*_*"}
                    disabled
                  />
                </Form.Group>
                <Form.Group className="mb-3">
                  <Form.Label>
                    {"Contact Person"}
                    <span className="redStreSpan">{"*"}</span>
                  </Form.Label>
                  <Form.Control
                    type="text"
                    value={!isEmpty(uploadFormObj) ? uploadFormObj["contact_person_name"] : "*_*"}
                    onChange={(e) => setUpdatedForm("contact_person_name", e.target.value)}
                    disabled={!isUpdateMode}
                  />
                </Form.Group>
                {bhareeAdminBasicTable?.data?.paymentTypes?.length > 0 && (
                  <Form.Group className="mb-3" controlId="formBasicEmail">
                    <Form.Label>
                      {"Select Payment Types"}
                      <span className="redStreSpan">{"*"}</span>
                    </Form.Label>

                    <CustomSelectDropdown
                      // disablePreSelectedValues
                      style={{
                        multiselectContainer: {
                          backgroundColor: "#f8f8f8",
                        },
                        chips: {
                          background: "#fbb040",
                          margin: 0,
                        },
                        option: {
                          background: "#fbb040",
                          color: "#FFFFFF",
                          borderBottom: "1px solid #FFFFFF",
                        },
                      }}
                      options={bhareeAdminBasicTable?.data?.paymentTypes}
                      onRemove={(e) => setUpdatedForm("payment_types", e)}
                      onSelect={(e) => setUpdatedForm("payment_types", e)}
                      selectedValues={uploadFormObj?.business_info?.payment_types}
                      displayValue={"name"}
                    />
                  </Form.Group>
                )}
              </Col>
            </Row>
            <Row className="m-0">
              <Col xs={12} md={6}>
                <Form.Group controlId="formFile" className="mb-3">
                  <Form.Label>
                    Upload Signature (PNG/JPG ≤ 2MB)<span className="redStreSpan">{"*"}</span>
                  </Form.Label>
                  {uploadFormObj?.business_info?.authorized_signature && (
                    <>
                      <br />
                      <Image
                        className="img-fluid"
                        src={companyInfo?.data?.business_info?.authorized_signature}
                        alt="Authorized Signature"
                        style={{ height: "100px" }}
                      />
                    </>
                  )}
                  <Form.Control
                    type="file"
                    accept="image/*"
                    onChange={handleFileChange}
                    className="custom-file-input"
                  />
                </Form.Group>
              </Col>
            </Row>

            {errorMsg && <p className="error-msg">{errorMsg}</p>}
            <div className="action-buttons">
              {isUpdateMode && (
                <>
                  <CustomButton
                    variant="primary"
                    buttonClasses={"close-btn"}
                    loading={requestCall?.loading}
                    onClick={() => setIsUpdateMode(false)}
                  >
                    {"close"}
                  </CustomButton>
                  <CustomButton
                    variant="primary"
                    buttonClasses={!requestCall?.loading ? "submit-btn" : "submit-btn-loading"}
                    type="submit"
                    loading={requestCall?.loading}
                  >
                    {"update"}
                  </CustomButton>
                </>
              )}
            </div>
          </Form>
        </Row>
      )}

      {/* {(() => {
                if (!isUpdateMode && !isEmpty(companyInfo.data)) {
                    return
                }
            })()} */}
    </Container>
  );
};

export default Companyinformation;
